export default __webpack_public_path__ + "static/expectium_logo_white-acccedb0bf41a0c5dc60a827244a893b.png";